export default "__VITE_ASSET__63565453__"